module.exports = __webpack_public_path__ + "img/ranking4.4371230d.png";